import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ICustomerBilling } from '../../data/interfaces/customer-billing.interface';

@Component({
  selector: 'app-customer-billing-form',
  templateUrl: './customer-billing-form.component.html',
  styleUrls: ['./customer-billing-form.component.scss']
})
export class CustomerBillingFormComponent implements OnInit {
  @Input() leaseId!: string;  // Cambiar de customerId a leaseId
  @Input() billing?: ICustomerBilling;
  @Input() mode: 'create' | 'edit' = 'create';
  @Output() onSave = new EventEmitter<any>();
  @Output() onCancel = new EventEmitter<void>();

  billingForm!: FormGroup;
  isSubmitting = false;

  // Opciones para dropdowns
  paymentMethods = [
    { label: 'Efectivo', value: '01' },
    { label: 'Cheque nominativo', value: '02' },
    { label: 'Transferencia electrónica', value: '03' },
    { label: 'Tarjeta de crédito', value: '04' },
    { label: 'Por definir', value: '99' }
  ];

  paymentTypes = [
    { label: 'Pago en una sola exhibición', value: 'PUE' },
    { label: 'Pago en parcialidades o diferido', value: 'PPD' }
  ];

  cfdiUsages = [
    { label: 'Gastos en general', value: 'G03' },
    { label: 'Adquisición de mercancías', value: 'G02' },
    { label: 'Construcciones', value: 'G01' },
    { label: 'Por definir', value: 'P01' }
  ];

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.initializeForm();
  }

  initializeForm() {
    this.billingForm = this.fb.group({
      businessName: [this.billing?.businessName || '', [Validators.required, Validators.maxLength(250)]],
      contractNumber: [this.billing?.contractNumber || '', [Validators.required, Validators.maxLength(100)]],
      paymentMethod: [this.billing?.paymentMethod || '', Validators.required],
      paymentType: [this.billing?.paymentType || '', Validators.required],
      cfdiUsage: [this.billing?.cfdiUsage || '', Validators.required],
      comments: [this.billing?.comments || '', Validators.maxLength(500)]
    });
  }

  get formTitle(): string {
    return this.mode === 'create' ? 'Nueva Configuración de Facturación' : 'Editar Configuración de Facturación';
  }

  get isFormValid(): boolean {
    return this.billingForm.valid;
  }

  onFormSubmit() {
    if (this.billingForm.valid) {
      this.isSubmitting = true;
      
      const formData = {
        ...this.billingForm.value,
        leaseId: this.leaseId  // Cambiar de customerId a leaseId
      };

      this.onSave.emit(formData);
    }
  }

  onFormCancel() {
    this.onCancel.emit();
  }

  hasError(field: string, errorType: string): boolean {
    const control = this.billingForm.get(field);
    return !!(control && control.errors && control.errors[errorType] && (control.dirty || control.touched));
  }

  getErrorMessage(field: string): string {
    const control = this.billingForm.get(field);
    if (!control || !control.errors) return '';

    const errors = control.errors;
    
    if (errors['required']) return `El campo es requerido`;
    if (errors['maxlength']) return `El campo excede la longitud máxima`;
    
    return '';
  }
}
